<template>
  <div>
    <LayoutHeadBanner
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <div class="container flex-box column layoutCards">
      <div class="card-tabs">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          class="card-tabs-slider"
        >
          <swiper-slide
            v-for="(slide, index) in getMenuFlat(
              'main',
              this.$store.state.selected_menu.pid
            )"
            :key="slide.key"
            :class="index === 0 ? 'current' : ''"
            class="card-tab"
          >
            <router-link :to="slide.full_url">
              <div class="img-box br-12" v-on:click="selectedCard = slide">
                <img
                  :src="_.get(slide, 'media.cover.devices.desktop')"
                  alt
                  class="img-absolute br-12"
                />
              </div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
      <Breadcrumb class="layout3" />
    </div>

    <div class="container layout-outer flex-box cards-layout">
      <div class="layout-left">
        <LayoutContent
          :itemData="$store.state.current_content"
          v-if="$store.state.current_content"
        />

        <a
          class="unique-app-form br-12 mt-55"
          v-if="
            _.get(this.$store.state.current_content, 'secondary.BannerBlock') &&
            _.get(this.$store.state.current_content, 'secondary.BannerBlock.conf.enabled') != '0'
          "
        >
          <div class="img-box br-12">
            <picture>
              <img
                :src="
                  _.get(
                    this.$store.state.current_content,
                    'secondary.BannerBlock.data.0.cover_image.0.url'
                  )
                "
                class="img-absolute br-12"
                alt
              />
            </picture>
            <div class="box-content flex-box between al-center">
              <h4 class="white font-34 noto-semibold">
                {{
                  _.get(
                    this.$store.state.current_content,
                    "secondary.BannerBlock.data.0.title"
                  )
                }}
              </h4>
              <SmartButton
                :cssclass="'btn sub bg-white'"
                :itemData="
                  _.get(
                    this.$store.state.current_content,
                    'secondary.BannerBlock.data.0.smartbuttons.0'
                  )
                "
                v-if="
                  _.get(
                    this.$store.state.current_content,
                    'secondary.BannerBlock.data.0.smartbuttons.0'
                  )
                "
              />
            </div>
          </div>
        </a>

        <UsefulTools
          :itemData="
            _.get($store.state.current_content, 'secondary.usefull_tools.conf')
          "
          v-if="
            _.get(
              $store.state.current_content,
              'secondary.usefull_tools.conf.enabled'
            ) == 1
          "
          :bg="'noPadding whiteCol overflow'"
          :firstLook="2.3"
          :ipadLook="1.5"
        />
      </div>
      <div class="layout-right">
        <ApplicationLinkBox
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.right_top_banner.conf.enabled'
            ) == 1
          "
          :itemData="
            _.get(
              this.$store.state.current_content,
              'secondary.right_top_banner'
            )
          "
        />

        <ProductBoxes
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.additional_widgets.conf.enabled'
            ) == 1
          "
          :itemData="
            _.get(
              this.$store.state.current_content,
              'secondary.additional_widgets'
            )
          "
        />
      </div>
    </div>

    <MoreWaysForBanking />
  </div>
</template>

<script>
import LayoutHeadBanner from "@/components/LayoutHeadBanner";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import LayoutContent from "@/components/LayoutContent";
import Breadcrumb from "@/components/Breadcrumb";
import MainMixin from "@/mixins/main";
import AliMixin from "@/mixins/ali";
import ApplicationLinkBox from "@/components/ApplicationLinkBox";
import UsefulTools from "@/components/UsefulTools";
import ProductBoxes from "@/components/ProductBoxes";
import SmartButton from "@/components/modules/SmartButton";

export default {
  mixins: [AliMixin, MainMixin],
  components: {
    LayoutHeadBanner,
    LayoutContent,
    Breadcrumb,
    MoreWaysForBanking,
    ApplicationLinkBox,
    UsefulTools,
    ProductBoxes,
    SmartButton,
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: "auto",
        watchOverflow: true,
      },
      selectedCard: {},
    };
  },
  computed: {
    siblings() {
      return this.getMenuFlat("main", this.$store.state.selected_menu.pid);
    },
    parentMenu() {
      return this.getMenuById(this.$store.state.selected_menu.pid);
    },
  },

  mounted() {
    this.startParralaxe();
  },
};
</script>


<style scoped>
.container.layout3 {
  padding: 0;
  margin: initial;
}
</style>
